export function generateTableHeader(
  id: string,
  numeric: boolean,
  disablePadding: boolean,
  label: string,
  enableSorting: boolean,
) {
  return {
    id,
    numeric,
    disablePadding,
    label,
    enableSorting,
  };
}

export function createNewAppServicePlan(
  appserviceplans: string[],
  item: string[],
  FarmId: number,
) {
  const indices = appserviceplans.map((plan) => Number(plan.split('-')[1]));
  indices.sort((a, b) => a - b);

  let newIndex = 0;
  for (let i = 0; i < indices.length; i++) {
    if (indices[i] > i) {
      newIndex = i;
      break;
    }
    if (i === indices.length - 1) {
      newIndex = indices.length;
    }
  }
  const NewPlan = `appserviceplan${FarmId}-${newIndex}-${item[0]}`;
  item = [NewPlan];
  return item;
}

export function RemoveDuplicateAppserviceplans(
  appAppservicePlans: string[],
): React.SetStateAction<string[]> {
  return [...new Set(appAppservicePlans)];
}

export function GetActionLink(routeComponents: string[]) {
  const path = routeComponents.join('/');
  return `/${path}`;
}

export function valueToText(value: number): string {
  return value.toString();
}
